import { CONFLUENCE_AIFC_PAGE_CREATE_KEY } from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import {
	type GeneratedVisualBlockCounts,
	getGeneratedVisualBlockCounts,
} from '@atlassian/rovo-content-bridge-api-commands/commands/generated-visual-block-counts';

/**
 * Reads the generated image / MAUI app block counts for analytics on events that describe a whole
 * assistant message. The counts belong to one generated page, so they are reported only when the
 * message has exactly one page-create action; otherwise there is no single page to attribute them
 * to, and nothing is reported.
 */
export const getPageCreateVisualBlockCounts = (
	actions: readonly Pick<MessageAction, 'key' | 'data'>[] | undefined,
): GeneratedVisualBlockCounts => {
	const pageCreateActions =
		actions?.filter((action) => action.key === CONFLUENCE_AIFC_PAGE_CREATE_KEY) ?? [];
	return pageCreateActions.length === 1
		? getGeneratedVisualBlockCounts(pageCreateActions[0].data)
		: {};
};
